var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "selected-city-picker" },
    [
      _vm.isOnline
        ? [
            _c("div", { staticClass: "selected-city-picker__container" }, [
              _c("div", { staticClass: "selected-city-picker__title" }, [
                _vm._v("\n        Укажите ваш город\n      ")
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "click-outside",
                      rawName: "v-click-outside",
                      value: _vm.clickOutsideSelectCityPicker,
                      expression: "clickOutsideSelectCityPicker"
                    }
                  ],
                  staticClass: "selected-city-picker__select"
                },
                [
                  _c(
                    "InputUI",
                    {
                      staticClass: "selected-city-picker__input",
                      attrs: {
                        value: _vm.searchText,
                        placeholder: "Введите город, регион"
                      },
                      on: {
                        "update:value": function($event) {
                          _vm.searchText = $event
                        },
                        focus: _vm.onFocus
                      }
                    },
                    [
                      _c("template", { slot: "before" }, [
                        _c(
                          "span",
                          { staticClass: "selected-city-picker__icon" },
                          [_c("Icon", { attrs: { icon: "r-search" } })],
                          1
                        )
                      ])
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.showList
                    ? _c(
                        "div",
                        {
                          ref: "searchList",
                          staticClass: "selected-city-picker__list",
                          on: {
                            mouseenter: _vm.onMouseEnterListSearch,
                            mouseleave: _vm.onMouseLeaveListSearch
                          }
                        },
                        [
                          _c(
                            "vue-custom-scrollbar",
                            {
                              staticClass: "selected-city-picker__list-scroll"
                            },
                            [
                              _c(
                                "div",
                                {
                                  ref: "searchListContent",
                                  staticClass:
                                    "selected-city-picker__list-content"
                                },
                                _vm._l(_vm.cityDadata, function(location) {
                                  return _c(
                                    "div",
                                    {
                                      key: location.code,
                                      staticClass:
                                        "item-selected-city-picker txt-m link-ui"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "city-picker-popover__results-link button-clean",
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.selectCity(location)
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "city-picker-popover__results-link-title"
                                            },
                                            [_vm._v(_vm._s(location.city))]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "city-picker-popover__results-link-subtext"
                                            },
                                            [_vm._v(_vm._s(location.region))]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                }),
                                0
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ]),
            _vm._v(" "),
            _vm.showFooter
              ? _c("div", { staticClass: "selected-city-picker__footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn-ui btn-ui--full-mob",
                      class: { disabled: !_vm.codeCity },
                      attrs: { type: "button" },
                      on: { click: _vm.setCity }
                    },
                    [_vm._v("\n        Выбрать\n      ")]
                  )
                ])
              : _vm._e()
          ]
        : [
            _c("div", { staticClass: "city-picker-popover__title" }, [
              _vm._v(
                "\n      Соединение с интернетом отсутствует, поэтому изменить город нельзя\n    "
              )
            ])
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }